module.exports = __webpack_public_path__ + "img/user.2aec17b9.svg";